import React from 'react';

const UserLoginActivityFormModal = React.lazy(() => import('../components/FormModal'));
const userLoginActivityModalRegistry = {
    core_userLoginActivityId: UserLoginActivityFormModal
};
export default userLoginActivityModalRegistry;
